// extracted by mini-css-extract-plugin
export default {"label":"TextForm_label__rouiX","input":"TextForm_input__QKDyr"};